import React from 'react';
import { BookOpen, Droplets, Moon, Sparkles, ShoppingCart } from 'lucide-react';
export function WhatsInside() {
  const items = [{
    icon: <Droplets className="w-6 h-6 text-amber-600" data-id="element-170" />,
    title: 'The "Golden Root" Tonic',
    description: 'The exact 3-ingredient recipe that shuts down systemic inflammation in 12 hours.'
  }, {
    icon: <BookOpen className="w-6 h-6 text-amber-600" data-id="element-171" />,
    title: 'The 2-Minute Lymphatic "Flush"',
    description: 'A simple self-massage technique to drain the fluid trapped in your face, ankles, and belly.'
  }, {
    icon: <Moon className="w-6 h-6 text-amber-600" data-id="element-172" />,
    title: 'The Cortisol Reset',
    description: 'How to signal your brain to stop storing "stress fat" while you sleep.'
  }, {
    icon: <Sparkles className="w-6 h-6 text-amber-600" data-id="element-173" />,
    title: 'Ancestral Beauty Secrets',
    description: 'The $5 grocery store mask that firms mature skin and restores your natural glow.'
  }, {
    icon: <ShoppingCart className="w-6 h-6 text-amber-600" data-id="element-174" />,
    title: 'The 7-Day Grocery List',
    description: 'Everything you need to "reset" your biology without breaking the bank.'
  }];
  return <section className="py-20 bg-white" data-id="element-175">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl" data-id="element-176">
        <div className="text-center mb-16" data-id="element-177">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-4" data-id="element-178">
            What’s Inside?
          </h2>
          <p className="text-xl text-stone-600" data-id="element-179">
            This isn’t just another "diet book." It is a{' '}
            <span className="font-bold text-amber-600" data-id="element-180">
              7-Day Transformation Blueprint.
            </span>
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3" data-id="element-181">
          {items.map((item, index) => <div key={index} className="bg-stone-50 rounded-xl p-8 border border-stone-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-182">
              <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center mb-6" data-id="element-183">
                {item.icon}
              </div>
              <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-184">
                {item.title}
              </h3>
              <p className="text-stone-600 leading-relaxed" data-id="element-185">
                {item.description}
              </p>
            </div>)}

          {/* Visual filler for grid balance if needed, or just center the last items */}
          <div className="bg-gradient-to-br from-amber-500 to-amber-600 rounded-xl p-8 text-white flex flex-col justify-center items-center text-center shadow-lg transform md:scale-105" data-id="element-186">
            <h3 className="text-2xl font-bold mb-2" data-id="element-187">Instant Access</h3>
            <p className="opacity-90" data-id="element-188">
              Start your transformation immediately after purchase.
            </p>
          </div>
        </div>
      </div>
    </section>;
}